import { DateTime } from 'luxon'
import { GracePeriodUnit } from './enums/GracePeriodUnit'
import GracePeriodJson from './interfaces/GracePeriodJson'

export default class GracePeriod {
  amount: number
  unit: GracePeriodUnit

  constructor(amount: number, unit: GracePeriodUnit) {
    this.amount = amount
    this.unit = unit
  }

  calculate(date: DateTime) {
    return date.plus({ [this.unit]: this.amount })
  }

  static fromJson(data: GracePeriodJson) {
    return new this(data.amount, data.unit)
  }
}
